import api from './api';

export const getAllSubjects = async () => {
    try {
        const response = await api.get('/subjects');
        return response.data;
    } catch (error) {
        console.error("Error fetching subjects:", error);
        throw error;
    }
};

export const createSubject = async (name) => {
    const response = await api.post('/subjects', { name });
    return response.data;
};

export const updateSubject = async (id, name) => {
    const response = await api.put(`/subjects/${id}`, { name });
    return response.data;
};

export const deleteSubject = async (id) => {
    await api.delete(`/subjects/${id}`);
};